import chickenFreshPackShot from '../images/product-photos/pack-shots/Fresh-packshot-chicken.jpg';
import beefFreshPackShot from '../images/product-photos/pack-shots/Fresh-packshot-beef.jpg';
import lambFreshPackShot from '../images/product-photos/pack-shots/Fresh-packshot-lamb.jpg';
import turkeyFreshPackShot from '../images/product-photos/pack-shots/Fresh-packshot-turkey.jpg';
import dryBeefImage from '../images/product-photos/pack-shots/Dry-packshot-beef.jpg';
import dryChickenImage from '../images/product-photos/pack-shots/Dry-packshot-chicken.jpg';
import JerkyTreatBeefSweetPotatoImage from '../images/our-food/addons/JerkyTreats-BeefSweetPotato.jpg';
import JerkyTreatChickenAppleImage from '../images/our-food/addons/JerkyTreats-ChickenApple.jpg';
import SweetPotatoTreatImage from '../images/our-food/addons/StripTreats-SweetPotato.jpg';
import ZoomiesImage from '../images/our-food/addons/Supplements-Zoomies.png';
import ChillPillsImage from '../images/our-food/addons/Supplements-ChillPills.png';
import BellyRubsImage from '../images/our-food/addons/Supplements-BellyRubs.png';
import appleLogo from '../images/Icons/apple-logo.svg';
import googlePlayLogo from '../images/Icons/google-play-logo.svg';
import { shared } from '../config';
import {
  supplementsDropdownsAndValues,
  treatsDropdownsAndValues,
} from '../testing/constants';

export const ACCOUNT_URL = '/api/set_account/';
export const ERROR_MESSAGE = `Changes failed, please refresh the page and try again.`;
export const PAYMENT_ERROR_MESSAGE =
  'There was an error processing your credit card.';
export const PAYMENT_ERROR_MESSAGE_INSUFFICIENT_FUNDS =
  'Your card has insufficient funds.';
export const TOAST_SERVER_MESSAGE =
  'Hmm. Something went wrong. Please try submitting again.';
export const TOAST_CLIENT_INCORRECT_PASSWORD_MESSAGE =
  'Current password is incorrect. Need to reset it? Click the link below.';
export const QUICK = 'quick';
export const CUSTOM_DATE = 'custom';
export const CALENDAR = 'calendar';
export const GF_PLAN_CHANGE_WARNING =
  "ⓘ We've updated our pricing. If you save any changes, it may result in a change to your price that you can't undo.";
export const GF_PLAN_CHANGE_WARNING_TESTING =
  "If you save any changes, it may result in a change to your price that you can't undo.";
export const CRO_PET_BIRTH_DATE = '2000-03-14';
export const MEAL_FREQUENCY_MAP = {
  1: 'One',
  2: 'Two',
  3: 'Three',
  4: 'Four',
  5: 'Five',
  6: 'Six',
  7: 'Seven',
  8: 'Eight',
};

export const MEAL_PLAN_PRODUCT_TYPES = {
  fresh: 'FR',
  dry: 'DY',
  mixed: 'MX',
};

export const MEAL_PLAN_PRODUCT_TYPES_LIST = Object.values(
  MEAL_PLAN_PRODUCT_TYPES,
);

export const FRESH_RECIPES = [
  {
    title: 'Beef',
    label: 'Add Beef',
    priceSymbol: 'low',
    value: 'beef',
    benefit: 'Nutrient-rich recipe',
    description:
      'Beef, sweet potatoes, and peas pack a hearty punch, providing dogs of all ages with all the essential nutrients they need to hit the ground running.',
    showMoreDetails: true,
    unavailableText:
      'Based on the food sensitivities {{pupName}} has, this recipe is unavailable due to food sensitivity concerns. Please contact our Canine Care team if you have any questions.',
    img: {
      src: beefFreshPackShot.src,
      alt: 'beef recipe',
    },
  },
  {
    title: 'Chicken',
    label: 'Add Chicken',
    priceSymbol: 'mid',
    value: 'chicken',
    benefit: 'Great for sensitive stomachs',
    description:
      'Chicken, carrots, and rice are a gentle, yet satisfying combination for dogs with sensitive stomachs, or picky palates.',
    showMoreDetails: true,
    unavailableText:
      'Based on the food sensitivities {{pupName}} has, this recipe is unavailable due to food sensitivity concerns. Please contact our Canine Care team if you have any questions.',
    img: {
      src: chickenFreshPackShot.src,
      alt: 'chicken recipe',
    },
  },
  {
    title: 'Lamb',
    label: 'Add Lamb',
    priceSymbol: 'high',
    value: 'lamb',
    benefit: 'Good for allergy prone dogs',
    description:
      'Real lamb, cranberries, and butternut squash keep mealtime fresh and exciting and give dogs the fuel they need to stay happy and healthy in the long run.',
    showMoreDetails: true,
    unavailableText:
      'Based on the food sensitivities {{pupName}} has, this recipe is unavailable due to food sensitivity concerns. Please contact our Canine Care team if you have any questions.',
    img: {
      src: lambFreshPackShot.src,
      alt: 'lamb recipe',
    },
  },
  {
    title: 'Turkey',
    label: 'Add Turkey',
    priceSymbol: 'mid',
    value: 'turkey',
    benefit: 'Features lean protein',
    description:
      'Turkey teams up with superfoods like blueberries and kale to provide dogs with a healthy helping of essential nutrients in every bite.',
    showMoreDetails: true,
    unavailableText:
      'Our turkey recipe is currently unavailable due to a national turkey shortage and supply chain disruption. In the meantime, enjoy our other healthy recipes.',
    img: {
      src: turkeyFreshPackShot.src,
      alt: 'turkey recipe',
    },
  },
];

export const DRY_RECIPES = [
  {
    title: 'Beef',
    label: 'Add Beef',
    priceSymbol: 'low',
    value: 'beef',
    benefit: 'Nutrient-rich recipe',
    description: `Hearty beef and sweet potatoes, plus nutrient-rich liver and oats, make for a well-rounded source of vitamins and minerals.`,
    showMoreDetails: true,
    unavailableText:
      'Based on the food sensitivities {{pupName}} has, this recipe is unavailable due to food sensitivity concerns. Please contact our Canine Care team if you have any questions.',
    img: {
      src: dryBeefImage.src,
      alt: 'beef recipe',
    },
  },
  {
    title: 'Chicken',
    label: 'Add Chicken',
    priceSymbol: 'low',
    value: 'chicken',
    benefit: 'Great for sensitive stomachs',
    description: `
      With chicken as the first ingredient, plus chickpeas, eggs, and veggies,
      this recipe packs antioxidants, protein, and fiber into one hearty meal.
      `,
    showMoreDetails: true,
    unavailableText:
      'Based on the food sensitivities {{pupName}} has, this recipe is unavailable due to food sensitivity concerns. Please contact our Canine Care team if you have any questions.',
    img: {
      src: dryChickenImage.src,
      alt: 'chicken recipe',
    },
  },
];

export const SAMPLER_BOX_SKU = 'SB-SAMPLEBOX';
export const SAMPLER_BOX_RECIPES = [
  'beef',
  'chicken',
  'lamb',
  'pork',
  'turkey',
];

export const SAMPLER_BOX_FEEDING_GUIDELINES_HREF =
  '/account/general-feeding-guidelines/';

export const ADDON_PRODUCT_TYPES = {
  treats: 'TR',
  supplements: 'SP',
  shopifySupplements: 'SPPL',
  shopifyTreats: 'TRT',
  dentalChews: 'DC',
};

export const REACTIVATION_CART_EXTRAS_PRODUCT_TYPE_MAP = {
  Supplements: 'SPPL',
  Treats: 'TRT',
  'Dental Chews': 'DC',
};

export const ADDON_SKUS = {
  beefjerky: 'JERKYSTRIPS-BE',
  chickenjerky: 'JERKYSTRIPS-CH',
  turkeyjerky: 'JERKYSTRIPS-TU',
  zoomies: 'ZOOMIES01',
  bellyrubs: 'BELLYRUBS01',
  chillpills: 'CHILLPILLS01',
  sweetpotatoes: 'SWEETPOTATOSLICES1',
  dentalchewxs: 'SUPP-DENT-XS',
  dentalchewsm: 'SUPP-DENT-SM',
  dentalchewmd: 'SUPP-DENT-MD',
  dentalchewlg: 'SUPP-DENT-LG',
  trainingtreatspb: 'TREAT-PBTRAINING-08',
  trainingtreatsparm: 'TREAT-PARMTRAINING-08',
  sweetpotatocrunch: 'TREAT-SWEETPOTATOCRNCH-08',
  applecrunchtreat: 'TREAT-APPLECRNCH-08',
  skinsupplement: 'SUPP-SKIN',
  immunesupplement: 'SUPP-IMMUNE',
  pbicecream: 'FR-ICECREAM-PBB',
  salmontreat: 'JERKYSTRIPS-SA',
};

export const SHOPIFY_ADDON_SKUS = {
  beefjerky: 'TRT-JERKYSTRIPS-BSP',
  chickenjerky: 'TRT-JERKYSTRIPS-CA',
  salmontreat: 'TRT-JERKYSTRIPS-SC',
  dentalchewxs: 'DC-DENTALCHEWS-XS',
  dentalchewsm: 'DC-DENTALCHEWS-SM',
  dentalchewmd: 'DC-DENTALCHEWS-MD',
  dentalchewlg: 'DC-DENTALCHEWS-LG',
  pbicecream: 'TRT-FROZENTREAT-PB',
  hipjointsupplement: 'SPPL-HIPJOINT',
  probioticsupplement: 'SPPL-PROBIOTIC',
  calmingsupplement: 'SPPL-CALMING',
  skinsupplement: 'SPPL-SKINCOAT',
  sweetpotatocrunch: 'TRT-CRUNCHY-SP',
  applecrunchtreat: 'TRT-CRUNCHY-AMB',
};
export const SHOPIFY_TO_LEGACY_EXTRAS_MAP = {
  'TRT-JERKYSTRIPS-BSP': 'JERKYSTRIPS-BE',
  'TRT-JERKYSTRIPS-CA': 'JERKYSTRIPS-CH',
  'TRT-JERKYSTRIPS-SC': 'JERKYSTRIPS-SA',
  'DC-DENTALCHEWS-XS': 'SUPP-DENT-XS',
  'DC-DENTALCHEWS-SM': 'SUPP-DENT-SM',
  'DC-DENTALCHEWS-MD': 'SUPP-DENT-MD',
  'DC-DENTALCHEWS-LG': 'SUPP-DENT-LG',
  'TRT-FROZENTREAT-PB': 'FR-ICECREAM-PBB',
  'SPPL-HIPJOINT': 'ZOOMIES01',
  'SPPL-PROBIOTIC': 'BELLYRUBS01',
  'SPPL-CALMING': 'CHILLPILLS01',
  'SPPL-SKINCOAT': 'SUPP-SKIN',
  'TRT-CRUNCHY-SP': 'TREAT-SWEETPOTATOCRNCH-08',
  'TRT-CRUNCHY-AMB': 'TREAT-APPLECRNCH-08',
};
export const LEGACY_TO_SHOPIFY_EXTRAS_MAP = {
  'JERKYSTRIPS-BE': 'TRT-JERKYSTRIPS-BSP',
  'JERKYSTRIPS-CH': 'TRT-JERKYSTRIPS-CA',
  'JERKYSTRIPS-SA': 'TRT-JERKYSTRIPS-SC',
  'SUPP-DENT-XS': 'DC-DENTALCHEWS-XS',
  'SUPP-DENT-SM': 'DC-DENTALCHEWS-SM',
  'SUPP-DENT-MD': 'DC-DENTALCHEWS-MD',
  'SUPP-DENT-LG': 'DC-DENTALCHEWS-LG',
  'FR-ICECREAM-PBB': 'TRT-FROZENTREAT-PB',
  ZOOMIES01: 'SPPL-HIPJOINT',
  BELLYRUBS01: 'SPPL-PROBIOTIC',
  CHILLPILLS01: 'SPPL-CALMING',
  'SUPP-SKIN': 'SPPL-SKINCOAT',
  'TREAT-SWEETPOTATOCRNCH-08': 'TRT-CRUNCHY-SP',
  'TREAT-APPLECRNCH-08': 'TRT-CRUNCHY-AMB',
};

// Shopify TODO: We can and should delete this post-Shopify MVP, this simplifies migration for now
export const BC_TO_SHOPIFY_SKU_MAP = {
  /* Beef & Sweet Potato Jerky Strips */
  'JERKYSTRIPS-BE': 'TRT-JERKYSTRIPS-BSP',
  /* Chicken and Apple Jerky Strips */
  'JERKYSTRIPS-CH': 'TRT-JERKYSTRIPS-CA',
  /* Salmon and Coconut Jerky Strips */
  'JERKYSTRIPS-SA': 'TRT-JERKYSTRIPS-SC',
  /* Peanut Butter Frozen Treat */
  'FR-ICECREAM-PBB': 'TRT-FROZENTREAT-PB',
  /* Crunchy Treats with Sweet Potato */
  'TREAT-SWEETPOTATOCRNCH-08': 'TRT-CRUNCHY-SP',
  /* Crunchy Treats with Apple & Mixed Berry */
  'TREAT-APPLECRNCH-08': 'TRT-CRUNCHY-AMB',
  /* Training Treats with Parmesan */
  'TREAT-PARMTRAINING-08': '',
  /* Training Treats with Peanut Butter */
  'TREAT-PBTRAINING-08': '',
  /* Skin & Coat Chews */
  'SUPP-SKIN': 'SPPL-SKINCOAT',
  /* Probiotic Chews */
  BELLYRUBS01: 'SPPL-PROBIOTIC',
  /* Hip & Joint Chews */
  ZOOMIES01: 'SPPL-HIPJOINT',
  /* Calming Chews */
  CHILLPILLS01: 'SPPL-CALMING',
  /* Dental Chews */
  'SUPP-DENT-XS': 'DC-DENTALCHEWS-XS',
  'SUPP-DENT-SM': 'DC-DENTALCHEWS-SM',
  'SUPP-DENT-MD': 'DC-DENTALCHEWS-MD',
  'SUPP-DENT-LG': 'DC-DENTALCHEWS-LG',
};

export const SHOPIFY_TO_BC_SKU_MAP = {
  /* Beef & Sweet Potato Jerky Strips */
  'TRT-JERKYSTRIPS-BSP': 'JERKYSTRIPS-BE',
  /* Chicken and Apple Jerky Strips */
  'TRT-JERKYSTRIPS-CA': 'JERKYSTRIPS-CH',
  /* Salmon and Coconut Jerky Strips */
  'TRT-JERKYSTRIPS-SC': 'JERKYSTRIPS-SA',
  /* Peanut Butter Frozen Treat */
  'TRT-FROZENTREAT-PB': 'FR-ICECREAM-PBB',
  /* Crunchy Treats with Sweet Potato */
  'TRT-CRUNCHY-SP': 'TREAT-SWEETPOTATOCRNCH-08',
  /* Crunchy Treats with Apple & Mixed Berry */
  'TRT-CRUNCHY-AMB': 'TREAT-APPLECRNCH-08',
  /* Skin & Coat Chews */
  'SPPL-SKINCOAT': 'SUPP-SKIN',
  /* Probiotic Chews */
  'SPPL-PROBIOTIC': 'BELLYRUBS01',
  /* Hip & Joint Chews */
  'SPPL-HIPJOINT': 'ZOOMIES01',
  /* Calming Chews */
  'SPPL-CALMING': 'CHILLPILLS01',
  /* Dental Chews */
  'DC-DENTALCHEWS-XS': 'SUPP-DENT-XS',
  'DC-DENTALCHEWS-SM': 'SUPP-DENT-SM',
  'DC-DENTALCHEWS-MD': 'SUPP-DENT-MD',
  'DC-DENTALCHEWS-LG': 'SUPP-DENT-LG',
};

export const MEAL_PLAN_TYPES = {
  DY: 'dry',
  FR: 'fresh',
  MX: 'mixed',
  BK: 'baked',
  HF: 'half_fresh',
};

export const ADDONS = [
  {
    sku: ADDON_SKUS.chickenjerky,
    productName: 'Chicken and Apple Jerky',
    title: 'Chicken and Apple Jerky',
    description: 'Simple and delicious, your dog will crave these treats.',
    productType: 'TR',
    subtitle: 'Jerky Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: JerkyTreatChickenAppleImage.src,
      alt: 'Chicken And Apple Recipe Jerky Image',
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: ADDON_SKUS.beefjerky,
    productName: 'Beef and Sweet Potato Jerky',
    title: 'Beef and Sweet Potato Jerky',
    description:
      'Clean, simple treats to reward the best and bravest behavior.',
    productType: 'TR',
    subtitle: 'Jerky Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: JerkyTreatBeefSweetPotatoImage.src,
      alt: 'Beef and Sweet Potato Recipe Jerky Image',
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: ADDON_SKUS.sweetpotatoes,
    productName: 'Sweet Potato Slices',
    title: 'Sweet Potato Slices',
    description:
      'One ingredient treats keep snack time simple, yet satisfying.',
    productType: 'TR',
    subtitle: 'Slice Treats',
    size: '1 bag (5oz.)',
    pricingInfo: { price: '$27.50', discountedPrice: '$22.00' },
    image: {
      src: SweetPotatoTreatImage.src,
      alt: 'Sweet Potato Slices Image',
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: ADDON_SKUS.zoomies,
    productName: 'Zoomies',
    title: 'Zoomies',
    description:
      'For healthy hips and joints, this supplement will add some pep to their step.',
    productType: 'SP',
    subtitle: 'Hip and Joint Formula',
    size: '1 jar (60 chews)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: ZoomiesImage.src,
      alt: 'Hip and Joint Supplement Image',
    },
    dropdowns: supplementsDropdownsAndValues.dropdowns,
  },
  {
    sku: ADDON_SKUS.chillpills,
    productName: 'Chill Pills',
    title: 'Chill Pills',
    description:
      'Get your pup to kick back and relax with these mellowing, all-natural supplements.',
    productType: 'SP',
    subtitle: 'Calming Formula',
    size: '1 jar (60 chews)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: ChillPillsImage.src,
      alt: 'Chill Pills Supplement Image',
    },
    dropdowns: supplementsDropdownsAndValues.dropdowns,
  },
  {
    sku: ADDON_SKUS.bellyrubs,
    productName: 'Belly Rubs',
    title: 'Belly Rubs',
    description:
      'Say goodbye to the tummy troubles with these delicious treats.',
    productType: 'SP',
    subtitle: 'Probiotic Formula',
    size: '1 jar (60 chews)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: BellyRubsImage.src,
      alt: 'Belly Rubs Supplement Image',
    },
    dropdowns: supplementsDropdownsAndValues.dropdowns,
  },
];

export const DENTAL_CHEWS_SKUS = [
  'SUPP-DENT-XS',
  'SUPP-DENT-SM',
  'SUPP-DENT-MD',
  'SUPP-DENT-LG',
  'DC-DENTALCHEWS-XS',
  'DC-DENTALCHEWS-SM',
  'DC-DENTALCHEWS-MD',
  'DC-DENTALCHEWS-LG',
];

export const MX_SUBSCRIPTION = {
  id: 'UUID',
  external_id: 'varchar[255]',
  created_on: '2025-02-01T12:00:00Z',
  customer_id: 'UUID',
  pet_id: 'UUID',
  address_id: 'UUID',
  cadence: 4,
  is_active: true,
  next_delivery_target: '2025-03-01',
  shipping_soon_timestamp: '2025-02-28T12:00:00',
  feeding_guidelines_id: 'UUID',
  mealplan_id: 'UUUID',
  mealplan_cadence_id: 'UUID',
  mealplan_combination_id: 'UUID',
  mealplan_data: {
    plan_type: 'MX',
    plan_type_name: 'mixed',
    percent_of_calories: '1.0',
    plan_metadata: {
      fresh_pack_size: '300',
      fresh_total_packs: '14',
      fresh_pack_per_day: '0.25',
      fresh_calories_per_day: '77.0',
      baked_cups_per_day: '0.25',
      baked_total_bag_weight: '4',
      baked_calories_per_day: '112.5',
      baked_total_bags: '2',
    },
    // GF plan pricing override
    price_override: '64.90',
    recipe_selections: {
      fresh: ['beef', 'lamb'],
      baked: ['chicken'],
    },
    items: [
      {
        sku: 'MP-FR-BEEF-300',
        qty: 7,
        // not GF plan pricing
        unit_price: '4.50',
      },
      {
        sku: 'MP-FR-LAMB-300',
        qty: 7,
        unit_price: '4.20',
      },
    ],
  },
  payment_method: {
    id: 'UUID',
    last_digits: '3366',
    expiry_year: '2030',
    expiry_month: '3',
    brand: 'Visa',
    status: 'PAID',
    type: 'CreditCard',
  },
};

export const MX_MEAL_PLAN_TYPES = [
  {
    plan_type: 'half_fresh',
    plan_type_name: 'half_fresh',
    mealplan_id: '123',
    available_cadences: [2, 4, 6],
    default_cadence: 2,
  },
  {
    plan_type: 'fresh',
    plan_type_name: 'fresh',
    mealplan_id: '123',
    available_cadences: [1, 2, 4, 6],
    default_cadence: 2,
  },
  {
    plan_type: 'baked',
    plan_type_name: 'baked',
    mealplan_id: '123',
    available_cadences: [2, 4, 6],
    default_cadence: 2,
  },
  {
    plan_type: 'mixed',
    plan_type_name: 'mixed',
    mealplan_id: '123',
    available_cadences: [2, 4, 6],
    default_cadence: 2,
  },
];

export const FLOATING_CTA_CONTENT = {
  text: 'OPEN IN THE APP',
  icons: [
    { src: appleLogo, alt: 'Apple Logo' },
    { src: googlePlayLogo, alt: 'Google Play Logo' },
  ],
};

export const OLLIE_ACCOUNT_DEEP_LINK = `https://www.${shared.SITE_NAME}/account/`;
export const APPLE_APP_STORE_URL =
  'https://apps.apple.com/us/app/ollie-human-grade-dog-food/id1614301164';
export const GOOGLE_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.ollie.mobile_app&hl=en_US&pli=1';

export const FLOATING_APP_CTA_KEY = 'FLOATING_APP_CTA';
